'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Ticker = require('./Ticker.css');

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Ticker = function (_React$Component) {
  _inherits(Ticker, _React$Component);

  function Ticker(props) {
    _classCallCheck(this, Ticker);

    var _this = _possibleConstructorReturn(this, (Ticker.__proto__ || Object.getPrototypeOf(Ticker)).call(this, props));

    _this.hasScrolled = false;
    _this.tickerScroll = null;
    _this.start = 0;
    _this.change = 200; // default, should be set later
    _this.currentTime = 0;
    _this.increment = 20;
    _this.duration = 300;
    _this.state = {
      atStart: true,
      atEnd: false
    };
    return _this;
  }

  _createClass(Ticker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'setScrollButtons',
    value: function setScrollButtons() {
      if (!this.hasScrolled && this.props.trackEvent) {
        this.props.trackEvent('ticker_scroll', {});
        this.hasScrolled = true;
      }
      var scrollLeft = this.tickerScroll.scrollLeft;
      var maxScrollLeft = this.tickerScroll.scrollWidth - this.tickerScroll.clientWidth;
      var atStart = scrollLeft === 0;
      var atEnd = Math.ceil(scrollLeft) === maxScrollLeft;

      if (atStart !== this.state.atStart || atEnd !== this.state.atEnd) {
        this.setState({
          atStart: atStart,
          atEnd: atEnd
        });
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      this.setScrollButtons();
    }
  }, {
    key: 'initTickerScroll',
    value: function initTickerScroll(ticker) {
      var _this2 = this;

      if (!ticker) {
        return;
      }
      this.tickerScroll = ticker;

      this.setScrollButtons();

      this.tickerScroll.onscroll = function () {
        _this2.setScrollButtons();
      };
    }

    // Scroll functions, adapted from https://gist.github.com/andjosh/6764939:

  }, {
    key: 'easeInOutQuad',
    value: function easeInOutQuad(time) {
      var newTime = time / this.duration * 2;
      if (newTime < 1) return this.change / 2 * newTime * newTime + this.start;
      newTime -= 1;
      return -(this.change / 2) * (newTime * (newTime - 2) - 1) + this.start;
    }
  }, {
    key: 'animateScroll',
    value: function animateScroll() {
      var _this3 = this;

      this.currentTime += this.increment;
      var maxScroll = this.tickerScroll.scrollWidth - this.tickerScroll.clientWidth;
      // Catch any cases where the ticker scrolls past the max possible distance
      this.tickerScroll.scrollLeft = Math.min(this.easeInOutQuad(this.currentTime), maxScroll);
      if (this.currentTime < this.duration) {
        setTimeout(function () {
          return _this3.animateScroll();
        }, this.increment);
      }
    }
  }, {
    key: 'scrollRight',
    value: function scrollRight() {
      this.start = this.tickerScroll.scrollLeft;
      this.currentTime = 0;
      this.change = this.tickerScroll.offsetWidth / 2;
      this.animateScroll();
    }
  }, {
    key: 'scrollLeft',
    value: function scrollLeft() {
      this.start = this.tickerScroll.scrollLeft;
      this.currentTime = 0;
      this.change = -this.tickerScroll.offsetWidth / 2;
      this.animateScroll();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var height = { height: this.props.height };
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + 'ticker'
        },
        _react2.default.createElement(
          'div',
          { onClick: function onClick() {
              return _this4.scrollLeft();
            }, tabIndex: '-1', 'aria-label': 'Scroll left', role: 'button', className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + ('buttonWrapper leftButton ' + (this.state.atStart ? 'hide' : ''))
          },
          _react2.default.createElement('div', {
            style: height,
            className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + 'scrollButton'
          })
        ),
        _react2.default.createElement(
          'div',
          { style: height, className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + 'tickerContentWrapper'
          },
          _react2.default.createElement(
            'div',
            { ref: function ref(ticker) {
                return _this4.initTickerScroll(ticker);
              }, className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + 'tickerContent'
            },
            this.props.children.map(function (child, idx) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                _react2.default.createElement(
                  'div',
                  { key: idx, className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + ((idx === 0 ? 'tickerCard firstCard' : 'tickerCard') || '')
                  },
                  child
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { onClick: function onClick() {
              return _this4.scrollRight();
            }, tabIndex: '-1', 'aria-label': 'Scroll right', role: 'button', className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + ('buttonWrapper rightButton ' + (this.state.atEnd ? 'hide' : ''))
          },
          _react2.default.createElement('div', {
            style: height,
            className: 'jsx-' + _Ticker2.default.__scopedHash + ' ' + 'scrollButton'
          })
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _Ticker2.default.__scopedHash,
          css: _Ticker2.default.__scoped
        })
      );
    }
  }]);

  return Ticker;
}(_react2.default.Component);

Ticker.propTypes = {
  children: _propTypes2.default.node.isRequired,
  trackEvent: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  height: _propTypes2.default.string
};

Ticker.defaultProps = {
  trackEvent: null,
  height: '100%'
};

exports.default = Ticker;